import React from 'react';
import Table from 'react-bootstrap/Table';
import { FaDownload, FaList } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import ColdDataApi from '../../api/ColdDataApi';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import ApiUiController from '../../controller/ApiUiController';
import { CSVLink } from 'react-csv';

class ColdDataList extends React.Component {

  constructor(props) {
    super(props);
    this.lists = [];
    this.state = { inApiCall: true };
    this.id = parseInt(props.match.params.id);
    this.path = this.props.match.path.replace(`/${this.id}`, '');


    const models = reactLocalStorage.getObject(Const.Model)
    const model = models.cold_data;

    this.options = models.user.options
      .map((salesPerson) => ({
        label: salesPerson?.label,
        value: salesPerson?.id,
      }));
    this.List = Util.isAllow(model.permission, Const.PermView);
  }

  componentDidMount() { 
    if(this.List) {
      ColdDataApi.getUserList(this.id, this.onReceived, this.onFail);
    }
  }
  onFail = () => this.setState({ ...this.state, inApiCall: false });
  onReceived = imports => {
    this.lists = imports;
    this.setState({ inApiCall: false });
  }

  getCsvData = () => {
    return this.lists.map((list, i) => ({
      'No'            : i + 1,
      'User'          : this.options.find(item => item.value === list.responsible_person)?.label || 'Unknown',
      'Campaign'      : list.campaign_name,
      'Calls'         : list.total_call,
      'Dials'         : list.total_dial,
      'Leads'         : list.leads_generated,
      'Connected'     : list.connected,
      'Not Connected' : list.not_connected,
      'Talk Time'     : list.total_call_talktime,
      'Avg Talk Time' : list.average_call_talktime,
    }));
  }

  details = index => this.props.navigate(`${this.path}/data/${this.lists[index].id}`);

  render() {
    if(!this.List) return null;
    let importUI = this.lists.map((list, _i) => (
      <tr key={`import_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{this.options.find(item => item.value === list.responsible_person)?.label || 'Unknown'}</td>
        <td>{list.complete_status === 1 ? 'Successfull' : 'In Progress'}</td>
        <td>{list.total_call}</td>
        <td>{list.total_dial}</td>
        <td>{list.leads_generated}</td>
        <td>{list.connected}</td>
        <td>{list.not_connected}</td>
        <td>{list.total_call_talktime}</td>
        <td>{list.average_call_talktime}</td>
        <td>{Util.serverStringToDisplayDateTime(list.updated_date)}</td>
        <td>
          <span className="buttons update" onClick={ () => this.details(_i) }>
            <FaList /> Details
          </span>
        </td>
      </tr>
    ));

    if(this.lists.length === 0) importUI = <tr><td colSpan="8">No Records Found</td></tr>;

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
            <div className="row">

              <div className="col-md-12">
                <div className="col-md-12 pb-3 d-flex justify-content-between align-items-center">
                  <h3>Cold Data</h3>
                  <CSVLink
                    data={this.getCsvData()}
                    filename={`cold-data-${this?.lists?.[0]?.campaign_name ?? this.id}.csv`}
                    className="btn btn-success btn-sm"
                  >
                    <FaDownload /> Export CSV
                  </CSVLink>
                </div>
              </div>
              
              <div className="col-md-12">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>User</th>
                      <th>Status</th>
                      <th>Calls</th>
                      <th>Dials</th>
                      <th>Leads</th>
                      <th>Connected</th>
                      <th>Not Connected</th>
                      <th>Talk Time</th>
                      <th>Avg. Talk Time</th>
                      <th>Updated Date</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ApiUiController inApiCall={this.props.inApiCall}>
                    { importUI }
                    </ApiUiController>
                  </tbody>
                </Table>
              </div>
            </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ColdDataList);